import { render, staticRenderFns } from "./PT630DairiOrderHisDetParts.vue?vue&type=template&id=ebfab5cc&"
import script from "./PT630DairiOrderHisDetParts.vue?vue&type=script&lang=js&"
export * from "./PT630DairiOrderHisDetParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports